"use client";

import { useUser } from "@clerk/nextjs";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

export function IdentifyUser() {
  const { user, isLoaded } = useUser();
  const posthog = usePostHog();

  const userId = user?.id;
  const email = user?.primaryEmailAddress?.emailAddress;
  const name = user?.fullName;

  useEffect(() => {
    if (!isLoaded || !posthog) return;

    if (userId) {
      posthog.identify(userId, { email, name });
    } else {
      posthog.reset();
    }
  }, [userId, email, name, isLoaded, posthog]);

  return null;
}
